export const specificLvzDataSelector = ({specificLvzData}) => specificLvzData